import React, { memo, useState, useEffect } from "react";
import { Avatar, Space, Popover, message, Divider, Typography, Button } from "antd";
import { UserOutlined } from "@ant-design/icons";
import QuickAdd from "../components/Drawer/QuickAdd";
import QuickMessage from "../components/Drawer/QuickMessage";
import { PermissionService } from "../Services/Permission/PermissionService";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const HeaderBar = () => {
  const navigate = useNavigate();

  const [omeUser, setOmeUser] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  // 🔁 Re-fetch user when popover opens
  useEffect(() => {
    if (popoverOpen) {
      const user = JSON.parse(localStorage.getItem("ome_user"));
      setOmeUser(user);
    }
  }, [popoverOpen]);

  const handleReloadPermission = async () => {
    try {
      if (!omeUser?.uid) {
        message.error("User ID not found!");
        return;
      }

      const response = await PermissionService.getPermissionDetailsById(
        omeUser.uid
      );

      localStorage.setItem(
        "ome_permission",
        JSON.stringify(response.data.permissions)
      );

      message.success("Permissions reloaded successfully!");
    } catch (error) {
      message.error("Failed to reload permissions.");
    }
  };

  const popoverContent = (
    <div style={{ minWidth: 250, padding: 10 }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "120px 1fr",
          rowGap: 6,
        }}
      >
        <Text strong>UID:</Text>
        <Text>{omeUser?.uid}</Text>

        <Text strong>Name:</Text>
        <Text>{omeUser?.name}</Text>

        <Text strong>Phone:</Text>
        <Text>{omeUser?.phone}</Text>

        <Text strong>Status:</Text>
        <Text>{omeUser?.status}</Text>

        <Text strong>Email:</Text>
        <Text>{omeUser?.email}</Text>

        <Text strong>Joined On:</Text>
        <Text>
          {omeUser?.added_on
            ? new Date(omeUser.added_on).toLocaleDateString()
            : "-"}
        </Text>
      </div>

      <Divider />

      <Button
        block
        onClick={() => navigate("/profile")}
      >
        Edit
      </Button>

      <Divider style={{ margin: "8px 0" }} />

      <Button
        block
        danger
        onClick={() => {
          localStorage.clear();
          window.location.reload();
        }}
      >
        Sign out
      </Button>
    </div>
  );

  return (
    <Space size="large">
      <QuickAdd />
      <QuickMessage />

      <Popover
        content={popoverContent}
        trigger="click"
        placement="bottom"
        open={popoverOpen}
        onOpenChange={setPopoverOpen}
      >
        <Avatar
          style={{ backgroundColor: "#87d068", cursor: "pointer" }}
          icon={<UserOutlined />}
        />
      </Popover>
    </Space>
  );
};

export default memo(HeaderBar);
